//src/pages/AIServices.jsx
// src/pages/AIServices.jsx
import React from 'react';
import AIFeatures from '../components/sections/AIFeatures';

const AIServices = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="py-20 bg-slate-900 text-white">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4 text-center">AI-Powered Legal Services</h1>
          <p className="text-xl text-center max-w-3xl mx-auto">
            Leveraging cutting-edge artificial intelligence to transform legal practice
          </p>
        </div>
      </div>
      <AIFeatures />
      {/* Additional AI-specific content here */}
    </div>
  );
};

export default AIServices;